import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CheckmarkOutlineSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.4294 2.73311C19.1352 2.43838 18.6578 2.43788 18.3636 2.73186L9.32087 11.7507L6.05829 8.20721C5.77638 7.9012 5.29974 7.88135 4.99321 8.16323C4.68692 8.44514 4.66731 8.92202 4.94923 9.22831L8.74321 13.3487C8.88216 13.4997 9.07661 13.5874 9.28165 13.5916C9.28716 13.5919 9.29247 13.5919 9.29774 13.5919C9.497 13.5919 9.68868 13.5127 9.82989 13.372L19.4279 3.79917C19.7229 3.50522 19.7234 3.02784 19.4294 2.73311Z"
      fill="currentColor"
    />
    <path
      d="M19.2462 9.24621C18.8299 9.24621 18.4925 9.58363 18.4925 10C18.4925 14.6829 14.6829 18.4925 10 18.4925C5.31734 18.4925 1.50754 14.6829 1.50754 10C1.50754 5.31734 5.31734 1.50754 10 1.50754C10.4163 1.50754 10.7538 1.17012 10.7538 0.753789C10.7538 0.337422 10.4163 0 10 0C4.48594 0 0 4.48594 0 10C0 15.5138 4.48594 20 10 20C15.5138 20 20 15.5138 20 10C20 9.58367 19.6626 9.24621 19.2462 9.24621Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckmarkOutlineIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CheckmarkOutlineSvg} {...props} />
);
